import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5bd75caf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "productInfo-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "left-box"
};
const _hoisted_4 = {
  class: "item-box one"
};
const _hoisted_5 = {
  class: "shield-box"
};
const _hoisted_6 = {
  class: "icon"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "蓝牙协议、WiFi协议", -1));
const _hoisted_8 = {
  class: "item-box two"
};
const _hoisted_9 = {
  class: "shield-box"
};
const _hoisted_10 = {
  class: "icon"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "区块链协议", -1));
const _hoisted_12 = {
  class: "item-box three"
};
const _hoisted_13 = {
  class: "shield-box"
};
const _hoisted_14 = {
  class: "icon"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "数据库协议", -1));
const _hoisted_16 = {
  class: "center-box"
};
const _hoisted_17 = {
  class: "center"
};
const _hoisted_18 = {
  class: "cloud",
  alt: "云起无垠"
};
const _hoisted_19 = {
  class: "item-box center-item"
};
const _hoisted_20 = {
  class: "shield-box"
};
const _hoisted_21 = {
  class: "icon"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "更多", -1));
const _hoisted_23 = {
  class: "right-box"
};
const _hoisted_24 = {
  class: "item-box one"
};
const _hoisted_25 = {
  class: "shield-box"
};
const _hoisted_26 = {
  class: "icon"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "私有金融协议", -1));
const _hoisted_28 = {
  class: "item-box two"
};
const _hoisted_29 = {
  class: "shield-box"
};
const _hoisted_30 = {
  class: "icon"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "工控协议", -1));
const _hoisted_32 = {
  class: "item-box three"
};
const _hoisted_33 = {
  class: "shield-box"
};
const _hoisted_34 = {
  class: "icon"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "5G协议", -1));
import { ref } from 'vue';
import { MOBILE_FUNC } from '@/uitl/currencyFunc';
export default {
  __name: 'protocolCom',
  setup(__props) {
    let isMobile = MOBILE_FUNC(),
      proportion = ref(null),
      fatherBox = ref(null);
    if (isMobile) {
      // 移动端
      proportion.value = ``;
      fatherBox.value = ``;
    } else {
      // PC端
      // if(window.innerWidth <= 1920){
      //     proportion.value = `transform: scale(${(window.innerWidth * 1) / 1920}) translateY(${ (((window.innerWidth * 1) / 1920) - 1) * 280 }px);`
      //     fatherBox.value = ''
      // }else{
      proportion.value = `transform: scale(${0.65},${0.65});`;
      fatherBox.value = `height: 483px;`;
      // }
    }
    console.log(window.innerWidth, screen.width);
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "graphical-box",
        style: _normalizeStyle(_unref(fatherBox))
      }, [_createElementVNode("div", {
        class: "graphical",
        style: _normalizeStyle(_unref(proportion))
      }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon1.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_7])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [_withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon2.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_11])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [_withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon3.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_15])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/radian-left.png'), "background-image"]]), _createElementVNode("div", _hoisted_16, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [_withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [[_directive_lazy, require('@/assets/img/codeProduct/product/cloud.png')]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/center-box-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [_withDirectives(_createElementVNode("i", _hoisted_21, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon7.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_22])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [_withDirectives(_createElementVNode("i", _hoisted_26, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon4.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_27])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [_withDirectives(_createElementVNode("i", _hoisted_30, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon5.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_31])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [_withDirectives(_createElementVNode("i", _hoisted_34, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon6.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_35])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/radian-right.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/center-bg.png'), "background-image"]])], 4)], 4)]);
    };
  }
};